import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.m.css";

const PriceCard = ({ price = "4000", className = "", range = "" }) => {
  function moneyRound(num) {
    return Math.ceil(num * 100) / 100;
  }

  const symbol = Math.sign(moneyRound(range)) === -1 ? "" : "+";

  return (
    <div className={styles["rate-tag"]}>
      <span>1 Gram</span>
      <h3>
        {price}{" "}
        <em style={{ color: Math.sign(moneyRound(range)) === -1 ? "green" : "red" }}>
          {range ? `${symbol}${moneyRound(range)}` : ""}
        </em>
      </h3>
    </div>
  );
};

PriceCard.propTypes = {
  price: PropTypes.string.isRequired,
  className: PropTypes.string,
  range: PropTypes.string
};
export default PriceCard;
